import airportCodes from './airport-codes.json';

export default class TripInfoCard {
  static insertPoint = document.getElementById('tripinfo');

  constructor(trip) {
    this.departing = trip.departing;
    this.arriving = trip.arriving;
    this.date = trip.date;
    this.co2 = trip.co2;
    this.source = trip.source;
    this.sourceModalInstance = null;
  }

  initSourceModal() {
    const modalElement = document.getElementById('sourceModal');
    modalElement.querySelector('img').src = `./images/sources/${this.source}.jpg`;
    modalElement.querySelector('a').href = `./images/sources/${this.source}.jpg`;
    this.sourceModalInstance = M.Modal.init(modalElement);
  }

  createSourcePreview() {
    if (!this.source) {
      return '';
    }
    const sourceContent = this.source.startsWith('http') ?
      `<a
        href="${this.source}""
        class="btn greens-green waves-effect waves-green btn-flat"
        target="_blank"
      >
        Quelle
      </a>` :
      `<img
        src="./images/sources/${this.source}_thumb.jpg"
        class="responsive-img hoverable z-depth-1 modal-trigger"
        data-target="sourceModal"
      />`
    return this.source ?
      `<div class="col s2 center">
        ${sourceContent}
      </div>` :
      '';
  }

  insert() {
    const date = (new Date(this.date)).toLocaleDateString('de-DE', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
    const card = (`
      <div class="card">
        <div class="card-content">
          <div class="row valign-wrapper">
            <div class="col ${this.source ? 's10' : 's12'}">
              <div class="row">
                <div class="col s6">
                  <div class="runway"><i class="material-icons departing">airplanemode_active</i></div>
                  ${airportCodes[this.departing]}
                </div>
                <div class="col s6">
                  <div class="runway"><i class="material-icons arriving">airplanemode_active</i></div>
                  ${airportCodes[this.arriving]}
                </div>
              </div>
              <div class="row">
                <div class="col s6 valign-wrapper">
                  <i class="material-icons">event</i>${date}
                </div>
                <div class="col s6">
                  <abbr title="CO2 Äquivalente">CO<sub>2-e</sub></abbr>:
                  ${this.co2.toLocaleString('de-DE', { maximumFractionDigits: 2 })} kg
                </div>
              </div>
            </div>
            ${this.createSourcePreview()}
          </div>
        </div>
      </div>
    `);

    this.initSourceModal();
    TripInfoCard.insertPoint.insertAdjacentHTML('beforeend', card);
  }

  destroy() {
    this.sourceModalInstance.destroy();
    TripInfoCard.insertPoint.firstElementChild.remove();
  }
}
